(function() {
'use strict';

const header = document.querySelector(".header");
const searchCloseIcon = document.querySelector(".search-close-icon");
const searchIcons = document.querySelectorAll(".search-icon");
const searchDropdown = document.querySelector(".search-dropdown");

searchIcons.forEach((elem) => {
  elem.addEventListener("click", toggleSearch);
});

searchCloseIcon.addEventListener("click", toggleSearch);

function toggleSearch() {
  searchDropdown.classList.toggle("active");
  searchDropdown.style.top = header.offsetHeight + 10 + "px";
}

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  waitForElement(".yotpo-email-link-action", 1000)
    .then(() => {
      document.querySelector(".yotpo-email-link-action").click();
    })
    .catch((e) => {});
});

// Function to be executed when the 'nav-active' class is added
function onNavActiveAdded() {
  // Select the elements
  const headerElement = document.querySelector("#shopify-section-header");
  const announcementBarElement = document.querySelector(
    "#shopify-section-announcement-bar"
  );
  const navElement = document.querySelector(".header-nav");

  if (headerElement && announcementBarElement && navElement) {
    // Get the heights of the elements
    const headerHeight = headerElement.offsetHeight;
    const announcementBarHeight = announcementBarElement.offsetHeight;

    // Calculate the combined height
    const totalHeight = headerHeight + announcementBarHeight;

    // Set the top style of .header-nav
    navElement.style.top = `${totalHeight}px`;
  } else {
    console.error("One or more elements were not found");
  }
}

// Initialize the MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      const currentClasses = mutation.target.classList;
      if (currentClasses.contains("nav-active")) {
        onNavActiveAdded();
      }

      if (currentClasses.contains("test-animated-reviews")) {
        const verifiedCustomersSpan = document.querySelector(".new-verified-customers--ratingstats span")
        if (verifiedCustomersSpan && !verifiedCustomersSpan.classList.contains("is-animated")) {
          animateReviews();
        }
      }
    }
  });
});

// Start observing the body element for attribute changes
const bodyElement = document.querySelector("body");
observer.observe(bodyElement, {
  attributes: true, // Listen for attribute changes
});

observer.observe(document.documentElement, {
  attributes: true,
});

function animateReviews() {
  const toAnimate = document.querySelector(
    ".new-verified-customers--ratingstats span"
  );

  toAnimate.classList.add("is-animated");

  let currentNumber = 970000;
  const targetNumber = 1000000;
  const increment = 1000;
  const interval = 100;

  function formatNumber(num) {
    return num.toLocaleString() + "+";
  }

  function animateNumber() {
    if (currentNumber < targetNumber) {
      currentNumber += increment;

      requestAnimationFrame(() => {
        toAnimate.textContent = formatNumber(currentNumber);
      });

      setTimeout(animateNumber, interval);
    } else {
      toAnimate.textContent = formatNumber(targetNumber);
    }
  }

  animateNumber();
}

})();
